export const noDistanceNoteTypes = ['freestyle', 'rap'];
export const noPointsNoteTypes: string[] = [];

export const MIDDLEA = 440;
export const SEMITONE = 69;

export const MAX_NAME_LENGTH = 20;
